module.exports = __webpack_public_path__ + "img/NTUA_LOGO.0ac83aba.svg";